module.exports = __webpack_public_path__ + "static/logo11-62d66dacd5b144d75a01e6c787cd5c7e.png";